import { handleHideModal } from 'components/global/_helpers/global.helpers';
import SimpleModal from 'components/global/SimpleModal';
import { handleSubmitDeleteRoom } from 'components/views/FounderRooms/_helpers/founderRooms.events';
import { $form, $view } from 'signals/global.signals';

const FounderDeleteRoomModal = () => (
  <SimpleModal
    show={$view.value?.activeModal === 'founder-room-delete'}
    title="Delete Room"
    isLoading={$view.value?.isModalLoading}
    onHide={handleHideModal}
    onPrimaryClick={handleSubmitDeleteRoom}
    primaryButtonText="Delete"
    primaryButtonVariant="danger"
    secondaryButtonText="Cancel"
    onSecondaryClick={handleHideModal}
  >
    Are you sure you want to delete <span className="text-info">{$form.value.name}</span>?
  </SimpleModal>

);

export default FounderDeleteRoomModal;
